import PropTypes from 'prop-types';
import './SettingsButton.css';

const SettingsButton = ({
  user = null,
  onClick = () => {},
}) => {
  return (
    <div className="settings-button" onClick={onClick}>
      {
        (user && user.avatar) ? (
          <img
            src={user.avatar}
            alt="Settings"
            title="Settings"
          />
        ) : (
          <div className="settings-button-placeholder" />
        )
      }
      <div className="settings-button-label">
        {(user) ? user.name : 'Guest'}
        {
          (user && user.organization) && (
            <span className="settings-button-organization">
              {user.organization}
            </span>
          )
        }
      </div>
    </div>
  );
};

SettingsButton.propTypes = {
  user: PropTypes.object,
  onClick: PropTypes.func,
};

export default SettingsButton;
